// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../k8-opt-exec-ST-a828a81199fe/bin/redo/bigcommerce-storefront/webpack.bin.runfiles/npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../k8-opt-exec-ST-a828a81199fe/bin/redo/bigcommerce-storefront/webpack.bin.runfiles/npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._f-0 {\n  display: flex;\n}\n\n._f-1 {\n  flex-direction: row;\n}\n\n._f-1._f-2 {\n    flex-direction: row-reverse;\n  }\n._f-3 {\n  flex-direction: column;\n}\n._f-3._f-2 {\n    flex-direction: column-reverse;\n  }\n\n._f-4 {\n  align-items: center;\n}\n._f-5 {\n  align-items: flex-start;\n}\n._f-6 {\n  align-items: flex-end;\n}\n._f-7 {\n  align-items: stretch;\n}\n._f-8 {\n  align-items: baseline;\n}\n\n._f-9 {\n  align-self: center;\n}\n._f-a {\n  align-self: flex-start;\n}\n._f-b {\n  align-self: flex-end;\n}\n._f-c {\n  align-self: stretch;\n}\n._f-d {\n  align-self: baseline;\n}\n\n._f-e {\n  justify-content: center;\n}\n._f-f {\n  justify-content: flex-start;\n}\n._f-g {\n  justify-content: flex-end;\n}\n._f-h {\n  justify-content: space-between;\n}\n._f-i {\n  justify-content: space-around;\n}\n._f-j {\n  justify-content: space-evenly;\n}\n\n._f-k {\n  flex-wrap: wrap;\n}\n\n._f-l {\n  flex-wrap: nowrap;\n}\n\n._f-m {\n  flex-wrap: wrap-reverse;\n}\n", ""]);
// Exports
export var flex = "_f-0";
export var row = "_f-1";
export var reverse = "_f-2";
export var column = "_f-3";
export var alignCenter = "_f-4";
export var alignFlexStart = "_f-5";
export var alignFlexEnd = "_f-6";
export var alignStretch = "_f-7";
export var alignBaseline = "_f-8";
export var alignSelfCenter = "_f-9";
export var alignSelfFlexStart = "_f-a";
export var alignSelfFlexEnd = "_f-b";
export var alignSelfStretch = "_f-c";
export var alignSelfBaseline = "_f-d";
export var justifyCenter = "_f-e";
export var justifyFlexStart = "_f-f";
export var justifyFlexEnd = "_f-g";
export var justifySpaceBetween = "_f-h";
export var justifySpaceAround = "_f-i";
export var justifySpaceEvenly = "_f-j";
export var wrapWrap = "_f-k";
export var wrapNowrap = "_f-l";
export var wrapWrapReverse = "_f-m";
export default ___CSS_LOADER_EXPORT___;
